import { render, screen } from "@testing-library/react";
import Terria from "../../../lib/Models/Terria";
import ViewState from "../../../lib/ReactViewModels/ViewState";
import { runInAction } from "mobx";
import Prompt from "../../../lib/ReactViews/Generic/Prompt";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
describe("HelpPrompt", function () {
  let terria;
  let viewState;
  beforeEach(function () {
    terria = new Terria({
      baseUrl: "./"
    });
    viewState = new ViewState({
      terria: terria,
      catalogSearchProvider: undefined
    });
  });
  describe("with basic props, when welcome message is enabled on startup", function () {
    it("does not render when welcome message is visible", function () {
      runInAction(() => {
        terria.configParameters.showWelcomeMessage = true;
        viewState.showWelcomeMessage = true;
      });
      render(/*#__PURE__*/_jsx(Prompt, {
        isVisible: terria.configParameters.showWelcomeMessage && !viewState.showWelcomeMessage,
        displayDelay: 0,
        dismissText: "",
        dismissAction: () => {},
        content: /*#__PURE__*/_jsx(_Fragment, {
          children: "foo"
        })
      }));
      expect(screen.queryByText("foo")).not.toBeInTheDocument();
    });
    it("renders when welcome message is not visible", function () {
      var _terria$configParamet;
      runInAction(() => {
        terria.configParameters.showWelcomeMessage = true;
        viewState.showWelcomeMessage = false;
      });
      render(/*#__PURE__*/_jsx(Prompt, {
        isVisible: ((_terria$configParamet = terria.configParameters.showWelcomeMessage) !== null && _terria$configParamet !== void 0 ? _terria$configParamet : false) && !viewState.showWelcomeMessage,
        displayDelay: 0,
        dismissText: "",
        dismissAction: () => {},
        content: /*#__PURE__*/_jsx(_Fragment, {
          children: "foo"
        })
      }));
      expect(screen.getByText("foo")).toBeVisible();
    });
  });
  describe("when welcome message is disabled on startup", function () {
    it("does not render", function () {
      var _terria$configParamet2;
      runInAction(() => {
        terria.configParameters.showWelcomeMessage = false;
      });
      render(/*#__PURE__*/_jsx(Prompt, {
        isVisible: ((_terria$configParamet2 = terria.configParameters.showWelcomeMessage) !== null && _terria$configParamet2 !== void 0 ? _terria$configParamet2 : false) && !viewState.showWelcomeMessage,
        displayDelay: 0,
        dismissText: "",
        dismissAction: () => {},
        content: /*#__PURE__*/_jsx(_Fragment, {
          children: "foo"
        })
      }));
      expect(screen.queryByText("foo")).not.toBeInTheDocument();
    });
  });
});